/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Filter_This_MonthInputs */

const en_ui_filter_this_month = /** @type {(inputs: Ui_Filter_This_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`this month`)
};

const de_ui_filter_this_month = /** @type {(inputs: Ui_Filter_This_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`diesen Monat`)
};

/**
* | output |
* | --- |
* | "this month" |
*
* @param {Ui_Filter_This_MonthInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_filter_this_month = /** @type {((inputs?: Ui_Filter_This_MonthInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Filter_This_MonthInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_filter_this_month(inputs)
	return de_ui_filter_this_month(inputs)
});